<template>
  <div style="width: 100%;">
    <v-chip-group
      v-model="selectedStaff"
      show-arrows
      mandatory
      active-class="primary--text"
    >
      <v-chip
        v-for="(staff) in myAttentionStaffs"
        :key="staff.euid"
        :value="staff.euid"
      >
        {{ $chPtObjData('chinStaffName', staff) }}
        <v-avatar
          v-if="showCount"
          right
          class="darken-2"
        >
          {{ staff.tasksCount }}
        </v-avatar>
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
import { workflowModule } from '@/store/moduleName'
import store from '@/store'
import { workflow } from '@/store/modules/workflow/workflow'
import { mapState } from 'vuex'

if (!store.state[workflowModule]) store.registerModule(workflowModule, workflow)

export default {
  components: {
  },
  props: {
    businessCode: {
      type: String,
      required: true
    },
    currEuid: {
      type: String,
      default: null
    },
    showCount: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selectedStaff: null
    }
  },
  computed: {
    ...mapState(workflowModule, {
      myAttentionStaffs: state => state.myAttentionStaffs
    })
  },
  watch: {
    selectedStaff: function (val) {
      this.$emit('update:currEuid', val)
    }
  },
  created () {
    if (this.currEuid) {
      this.selectedStaff = this.currEuid
    }
    this.$store.dispatch(workflowModule + '/getMyAttentionStaffs', this.businessCode)
  },
  methods: {
    refresh () {
      this.$store.dispatch(workflowModule + '/getMyAttentionStaffs', this.businessCode)
    }
  }
}
</script>
